export const PERMISSION_KEY_MAP = {
  dashboard: "Dashboard",
  usermanagement: "User Management",
  "roles-permissions": "Role Management",
  companies: "Client Company",
  properties: "Property",
  violations: "Violations",
  complaints: "Complaints",
  reports: "Reports",
  settings: "Settings",
};

export const MENU_ITEMS = [
  {
    id: "dashboard",
    label: "Dashboard",
    href: "/dashboard",
  },
  {
    id: "usermanagement",
    label: "User Management",
    href: "/usermanagement",
  },
  {
    id: "roles-permissions",
    label: "Roles & Permissions",
    href: "/roles-permissions",
  },
  {
    id: "companies",
    label: "Property Companies",
    href: "/companies",
  },
  {
    id: "properties",
    label: "Properties",
    href: "/properties",
  },
  {
    id: "violations",
    label: "Violation Report ",
    href: "/violations",
  },
  {
    id: "complaints",
    label: "Complaints",
    href: "/complaints",
  },
  {
    id: "reports",
    label: "Reports",
    href: "/reports",
  },
  {
    id: "settings",
    label: "Settings",
    href: "/settings",
  },
];

/**
 * Finds the first accessible path for a user based on their role and permissions.
 * @param {string} userType - The user's role (e.g., 'porter', 'admin').
 * @param {Object} permissions - The user's permission object from the API.
 * @returns {string} - The destination href.
 */
export const getFirstAccessiblePath = (userType, permissions) => {
  const accessibleItem = MENU_ITEMS.find((item) => {
    // 1. Check Role-based restrictions
    if (item.id === "dashboard" && userType === "porter") {
      return false;
    }

    // 2. Check Permission-based restrictions
    const permKey = PERMISSION_KEY_MAP[item.id];
    if (item.id === "dashboard") return true; // Non-porters, non-i4staff can always see dashboard if no other check exists

    return permissions?.[permKey]?.view === true;
  });

  return accessibleItem ? accessibleItem.href : "/dashboard"; // Fallback to dashboard or a login page
};
